/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Košík`
};

const da_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Kurv`
};

const de_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Warenkorb`
};

const en_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Cart`
};

const es_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Carrito`
};

const fr_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Panier`
};

const hu_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Kosár`
};

const it_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Carrello`
};

const nl_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Winkelwagen`
};

const pl_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Koszyk`
};

const pt_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Carrinho`
};

const sv_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Kundvagn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart", locale)
	if (locale === "cs") return cs_cart(inputs)
	if (locale === "da") return da_cart(inputs)
	if (locale === "de") return de_cart(inputs)
	if (locale === "en") return en_cart(inputs)
	if (locale === "es") return es_cart(inputs)
	if (locale === "fr") return fr_cart(inputs)
	if (locale === "hu") return hu_cart(inputs)
	if (locale === "it") return it_cart(inputs)
	if (locale === "nl") return nl_cart(inputs)
	if (locale === "pl") return pl_cart(inputs)
	if (locale === "pt") return pt_cart(inputs)
	return sv_cart(inputs)
};